import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=bfa78df4&scoped=true&"
import script from "./payments.vue?vue&type=script&lang=js&"
export * from "./payments.vue?vue&type=script&lang=js&"
import style0 from "./payments.vue?vue&type=style&index=0&id=bfa78df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa78df4",
  null
  
)

export default component.exports